package com.loyola.acessoescola.ui.registered

import acessoescola.composeapp.generated.resources.Res
import acessoescola.composeapp.generated.resources.delete
import acessoescola.composeapp.generated.resources.edit
import acessoescola.composeapp.generated.resources.edit_document_24px
import acessoescola.composeapp.generated.resources.facial
import acessoescola.composeapp.generated.resources.person_24px
import acessoescola.composeapp.generated.resources.sync_24px
import acessoescola.composeapp.generated.resources.user_icon
import androidx.compose.animation.core.LinearEasing
import androidx.compose.animation.core.RepeatMode
import androidx.compose.animation.core.animateFloat
import androidx.compose.animation.core.infiniteRepeatable
import androidx.compose.animation.core.rememberInfiniteTransition
import androidx.compose.animation.core.tween
import androidx.compose.foundation.background
import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.IntrinsicSize
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.defaultMinSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material3.AssistChipDefaults
import androidx.compose.material3.Button
import androidx.compose.material3.Card
import androidx.compose.material3.ElevatedAssistChip
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.Text
import androidx.compose.material3.contentColorFor
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.rotate
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import com.loyola.acessoescola.ui.theme.AcessoEscolaTheme
import com.loyola.acessoescola.ui.theme.darkScheme
import com.loyola.acessoescola.ui.theme.lightScheme
import io.kamel.image.KamelImage
import io.kamel.image.asyncPainterResource
import org.jetbrains.compose.resources.stringResource
import org.jetbrains.compose.resources.vectorResource

@Composable
fun CommonMainAuthorizer(
    imageUrl: String,
    deleteRecord: () -> Unit,
    fullName: String,
    navToEditRecord: () -> Unit,
    bound: String,
    modifier: Modifier
){
    val colorScheme = if (isSystemInDarkTheme()) darkScheme else lightScheme
    val fullNameBackgroundColor = colorScheme.secondary
    val fullNameForeColor = contentColorFor(fullNameBackgroundColor)

    //controla em qual registro deve aparecer o icone de loading
    var deleteRequested by remember { mutableStateOf("") }

    val infiniteTransition = rememberInfiniteTransition()

    val rotation by infiniteTransition.animateFloat(
        initialValue = 0f,
        targetValue = -360f,
        animationSpec = infiniteRepeatable(
            animation = tween(2500, easing = LinearEasing),
            repeatMode = RepeatMode.Restart
        )
    )

    Card(
        modifier = modifier
    ) {
        Row(
            modifier = Modifier
                .background(colorScheme.inversePrimary)
        ) {
            Column(modifier = Modifier.padding(8.dp)) {
                Card(
                    modifier = Modifier.size(100.dp),
                    shape = CircleShape
                ) {
                    KamelImage(
                        resource = { asyncPainterResource(data = imageUrl) },
                        contentDescription = stringResource(Res.string.facial),
                        contentScale = ContentScale.Crop,
                    )
                }
                Button(
                    onClick = {
                        deleteRecord()
                        deleteRequested = imageUrl //utiliza a imageUrl como identificador únido do delete
                    },
                    enabled = imageUrl != deleteRequested
                ) {
                    Row(
                        modifier = Modifier.height(intrinsicSize = IntrinsicSize.Min),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        if (imageUrl == deleteRequested) {
                            Icon(
                                imageVector = vectorResource(Res.drawable.sync_24px),
                                contentDescription = null,
                                modifier = Modifier.rotate(rotation)
                            )
                        }
                        Text(text = stringResource(Res.string.delete))
                    }
                }
            }
            Column {
                Row(
                    verticalAlignment = Alignment.CenterVertically,
                    modifier = Modifier.background(fullNameBackgroundColor)
                        .height(IntrinsicSize.Min)
                ) {
                    Icon(
                        imageVector = vectorResource(Res.drawable.person_24px),
                        contentDescription = stringResource(Res.string.user_icon),
                        modifier = Modifier
                            .defaultMinSize(28.dp, 28.dp)
                    )
                    Text(
                        text = fullName,
                        color = fullNameForeColor,
                        modifier = Modifier.weight(1f)
                    )
                    IconButton(
                        onClick = { navToEditRecord() },
                        modifier = Modifier
                            .defaultMinSize(28.dp, 28.dp)
                    ) {
                        Icon(
                            imageVector = vectorResource(Res.drawable.edit_document_24px),
                            contentDescription = stringResource(Res.string.edit),
                        )
                    }
                }
                HorizontalDivider()
                ElevatedAssistChip(
                    onClick = {},
                    label = { Text(text = bound) },
                    colors = AssistChipDefaults.elevatedAssistChipColors().copy(
                        containerColor = colorScheme.primary,
                        labelColor = colorScheme.onPrimary
                    )
                )

            }
        }
    }
}

@Preview
@Composable
private fun CommonMainAuthorizerPreview(){
    AcessoEscolaTheme {
        CommonMainAuthorizer(
            imageUrl = "",
            deleteRecord = { },
            fullName = "Teste Interface Preview",
            navToEditRecord = { },
            bound = "Parente",
            modifier = Modifier.fillMaxWidth()
                .padding(vertical = 4.dp)
        )
    }
}